import { render, staticRenderFns } from "./MagnifyIcon.vue?vue&type=template&id=5c86cd36&scoped=true"
import script from "./MagnifyIcon.vue?vue&type=script&lang=js"
export * from "./MagnifyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c86cd36",
  null
  
)

export default component.exports